<template>
  <div class="ip-query" >
    <el-row>
      <el-col :span="12" :offset="10">
        <el-form :model="formData" label-width="80px" class="ip-query-form">
          <el-form-item label="IP地址">
            <el-input v-model="formData.ip" placeholder="请输入IP地址"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryIP()">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row v-if="result">
      <el-col :span="12" offset="6">
        <div class="ip-result">
          <div><span class="label">查询结果：</span></div>
          <div><span class="label">省份：</span>{{ result.province }}</div>
          <div><span class="label">城市：</span>{{ result.city }}</div>

        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        ip: ''
      },
      result: null
    };
  },
  methods: {
    queryIP() {
		if(this.formData.ip==""){
			this.$notify({
				title: '消息提示',
				message: "ip不要为空！",
				type: 'error'
			});
			return
		}
      // 模拟查询操作，比如向后端发送请求获取IP信息
      // 假设这里使用了异步请求，返回的数据格式为 { ip, country, province, city, isp }
 this.$api.queryIpForAddress({ip:this.formData.ip}).then(res=>{
	if(res.data.code==200){
		this.result=res.data.data
	}else{
		this.$notify({
			title: '消息提示',
			message: res.data.msg,
			type: 'error'
		});
	}
 })
    }
  }
};
</script>

<style scoped>
.ip-query {
  padding: 20px;
}

.ip-query-form {
  width: 320px;
}

.ip-result {
  margin-top: 20px;
  text-align: center;
}

.ip-result .label {
  font-weight: bold;
}
</style>